import {type GlobalState} from '../../types/store';

export const getFatalErrors = (state: GlobalState) => state.fatalErrors;
